export const PresInfo = {
    "img": "./images/cabinet/2026-2027/ava.jpeg",
    "name": "Ava Brazell",
    "year": "2026-2027",
    "desc": ""
}